import { Row, Spin, Empty, Typography } from "antd";
import { useTranslation } from "react-i18next";

import { BUTTON_KEYS } from "@/constants/Button";
import { EditButton } from "@/ui/edit-button";

const EmptySection = ({ onButtonClick }) => {
  const { t } = useTranslation();

  return (
    <>
      <Typography.Title level={5}>
        {t("intervention:noTemplate")}
      </Typography.Title>
      <EditButton
        key={BUTTON_KEYS.EDIT}
        onClick={onButtonClick}
        style={{ marginTop: "20px" }}
      >
        {t("intervention:addTemplate")}
      </EditButton>
    </>
  );
};

const WithoutTemplate = ({ loading, onButtonClick }) => {
  return (
    <Row justify="center" align="middle" style={{ height: "100%" }}>
      {loading ? (
        <Spin />
      ) : (
        <Empty description={<EmptySection onButtonClick={onButtonClick} />} />
      )}
    </Row>
  );
};

export default WithoutTemplate;
